import { connect } from 'react-redux'
import { switchLayer } from './actions'
import React from 'react'
import BaseLayersButtons from '../components/buttonToggler/index';
import {wmsLayer, wmsBWLayer, wmsOrtoLayer, wmsTopo75Layer} from './assets';
import {map} from '../map/map';

const mapStateToPropsRes = (state) => {

  for (var i = state.baseLayers.layers.length - 1; i >= 0; i--) {
    if(state.baseLayers.layers[i].id == state.baseLayers.activeLayer) {
      var activeBtt = state.baseLayers.layers[i].id;
      break;
    }
  }

  return {
    activeBtt: activeBtt,
    buttons: state.baseLayers.layers,
    width: 135
  }
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    onClick: data => {
      if (data == 'topo75') {
        map.getView().setMaxZoom(15);

      } else {
        map.getView().setMaxZoom(18);
      }

      dispatch(switchLayer(data));
    }
  }
}

const BaseLayerBttCont = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(BaseLayersButtons)

const LayerButtons = () => (
  <BaseLayerBttCont />
);

var done = false;
var layerIni = function() {

  if(done) {
    return;
  }

  done = true;

  map.addLayer(wmsLayer);
  map.addLayer(wmsBWLayer);
  map.addLayer(wmsOrtoLayer);
  map.addLayer(wmsTopo75Layer);
}

class LayerButtonsComp extends React.Component {

  componentDidMount(){

      layerIni();
   /*  this.timerID = setTimeout(
         () =>   layerIni(),
          2000
        );*/
  }

  render() {

    return (<LayerButtons />);
  }
}



export default LayerButtonsComp



// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/baseLayers/container.js